import { Component } from '@angular/core';
import { CustomerDataComponent } from '../customer-data.component';

@Component({
  selector: 'vpfa-customer-data-web',
  templateUrl: './customer-data-web.component.html',
  styleUrls: ['./customer-data-web.component.scss'],
})
export class CustomerDataWebComponent extends CustomerDataComponent {}
